export const LOGIN_INITIALISE_SUCCESS = "LOGIN_INITIALISE_SUCCESS";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";

export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";

export const SET_DROPDOWN_MENU_ITEMS_LIST = "SET_DROPDOWN_MENU_ITEMS_LIST";

//Tank Midnight
export const ACTIVE_ROW_EDITING = "ACTIVE_ROW_EDITING";
export const SET_DATA_BY_DAY = "SET_DATA_BY_DAY";
export const UPDATE_DATA_BY_DAY = "UPDATE_DATA_BY_DAY";
export const SET_DATA_FILTERED_BY_MATERIAL = "SET_DATA_FILTERED_BY_MATERIAL";

//Sale At External
export const SHOW_DO_LIST = "SHOW_DO_LIST";
// --Edit/Create Form
export const IS_BAG = "IS_BAG";
export const IS_EDITING = "IS_EDITING";
export const SET_MASTER_DO_MODIFIED = "SET_MASTER_DO_MODIFIED";
export const SET_DATA_FOR_GGC_TRANS = "SET_DATA_FOR_GGC_TRANS";
export const SET_DATA_FOR_GGC_TRANS_DO_ITEM = "SET_DATA_FOR_GGC_TRANS_DO_ITEM";
export const SET_DO_ITEMS = "SET_DO_ITEMS";
export const SET_DO_SUB_ITEMS = "SET_DO_SUB_ITEMS";

//User Management
export const SET_FORM_DATA_FROM_TABLE_ROW = "SET_FORM_DATA_FROM_TABLE_ROW";
export const SET_IS_EDITING_USER = "SET_IS_EDITING_USER";
export const SET_IS_CREATING_USER = "SET_IS_CREATING_USER";
export const SET_ALL_USERS = "SET_ALL_USERS";

//Role Master
export const SET_FORM_DATA_FROM_TABLE_ROLE_MASTER = "SET_FORM_DATA_FROM_TABLE_ROLE_MASTER";
export const SET_IS_EDITING_ROLE = "SET_IS_EDITING_ROLE";
export const SET_IS_CREATING_ROLE = "SET_IS_CREATING_ROLE";
export const SET_ALL_ROLES = "SET_ALL_ROLES";

//Plan Management
export const SET_PLAN_MANAGE_SEARCH = "SET_PLAN_MANAGE_SEARCH";
export const SET_PLAN_DATA_ROW = "SET_PLAN_DATA_ROW";
export const SET_PLAN_DASHBOARD_DATA = "SET_PLAN_DASHBOARD_DATA";
export const SET_PLAN_DASHBOARD_SEARCH = "SET_PLAN_DASHBOARD_SEARCH";

//Email Group
export const SET_FORM_DATA_FROM_TABLE_EMAIL_GROUP = "SET_FORM_DATA_FROM_TABLE_EMAIL_GROUP";
export const SET_IS_EDITING_EMAIL_GROUP = "SET_IS_EDITING_EMAIL_GROUP";
export const SET_IS_CREATING_EMAIL_GROUP = "SET_IS_CREATING_EMAIL_GROUP";
export const SET_ALL_EMAIL_GROUPS = "SET_ALL_EMAIL_GROUPS";

//Email Audit
export const SET_FORM_DATA_FROM_TABLE_EMAIL_AUDIT = "SET_FORM_DATA_FROM_TABLE_EMAIL_AUDIT";
export const SET_START_DATE = "SET_START_DATE";
export const SET_END_DATE = "SET_END_DATE";

//Operation Team Master
export const SET_FORM_DATA_FROM_TABLE_OPERATION_TEAM_MASTER = "SET_FORM_DATA_FROM_TABLE_OPERATION_TEAM_MASTER";
export const SET_IS_EDITING_OPERATION_TEAM = "SET_IS_EDITING_OPERATION_TEAM";
export const SET_IS_CREATING_OPERATION_TEAM = "SET_IS_CREATING_OPERATION_TEAM";
export const SET_ALL_OPERATION_TEAMS = "SET_ALL_OPERATION_TEAMS";

//Privilege Manager
export const SET_APPLIED_PERMISSIONS = "SET_APPLIED_PERMISSIONS";
export const SET_PRIV_MANAGER_ROLE_SELECTED_PERMISSIONS = "SET_PRIV_MANAGER_ROLE_SELECTED_PERMISSIONS";
export const SET_TEST_PERMISSIONS = "SET_TEST_PERMISSIONS";
export const SET_PAGES = "SET_PAGES";
export const CANCEL_PERMISSIONS = "CANCEL_PERMISSIONS";
export const SET_USER_LOGIN = "SET_USER_LOGIN";

//Theme
export const SET_IS_DARK = "SET_IS_DARK";

export const SET_DIALOG = "SET_DIALOG";